import "reflect-metadata";
import {plainToClass, Type} from "class-transformer";

export enum DeviceType {
    DESKTOP = "DESKTOP",
    SMARTPHONE = "SMARTPHONE",
    TABLET = "TABLET",
    UNKNOWN = "UNKNOWN",
}

export interface Device {
    getType(): DeviceType;
    getUrl(): string;
}

class DeviceImpl implements Device{
    private type: DeviceType = DeviceType.UNKNOWN
    private url: string = ""

    getType(): DeviceType {
        return this.type;
    }

    getUrl(): string {
        return this.url;
    }
}
export interface TeamMember {
    getName(): string;
    getCount(): number;
}

class TeamMemberIml implements TeamMember{
    private name: string = ""
    private count: number = 1

    getName(): string {
        return this.name;
    }

    getCount(): number {
        return this.count;
    }
}

export interface PortfolioProject {
    getId(): string;
    getTitle(): string;
    getDevices(): Device[];
    getTeam(): TeamMember[];
    getPeriod(): string
    getDuration(): string;
    getStack(): string
    getDescription(): string
    getFeatures(): string[]
    getProcessPicture(): string
    getInterfaceImages(): Device[]
    getProcessPictureStyle(): object
}

class PortfolioProjectImpl implements PortfolioProject {
    private id: string = "";
    private title: string = "";
    private period: string = "";
    private duration: string = "";
    private stack: string = "";
    private description: string = "";
    private features: string[] = [];
    private processPicture: string = "";

    @Type(() => DeviceImpl)
    private interfaceImages: Device[] = [];

    @Type(() => DeviceImpl)
    private devices: Device[] = [];

    @Type(() => TeamMemberIml)
    private team: TeamMember[] = [];

    getId(): string {
        return this.id;
    }

    getTitle(): string {
        return this.title;
    }

    getDevices(): Device[] {
        return this.devices;
    }

    getTeam(): TeamMember[] {
        return this.team;
    }

    getPeriod(): string {
        return this.period;
    }

    getDuration(): string {
        return this.duration;
    }

    getStack(): string {
        return this.stack;
    }

    getDescription(): string {
        return this.description;
    }

    getFeatures(): string[] {
        return this.features;
    }

    getInterfaceImages(): Device[] {
        return this.interfaceImages;
    }

    getProcessPicture(): string {
        if(this.processPicture.length > 0) {
            return require(`./${this.processPicture}`);
        }
        return '';
    }

    getProcessPictureStyle(): object {
           return {
               backgroundImage: `url(${this.getProcessPicture})`,
           }
    }

}

export function fromJson(json: object[]): PortfolioProject[] {
    return plainToClass(PortfolioProjectImpl, json);
}
